export default {
  FILTER_DEPARTMENT_LIST: 'FilterDepartmentList',
  SORT_DEPARTMENT_LIST: 'SortDepartmentList',
  LOAD_DEPARTMENT_LIST_START: 'LoadDepartmentListStart',
  LOAD_DEPARTMENT_LIST_END: 'LoadDepartmentListEnd',
  TOGGLE_DEPARTMENT_LIST_CONFIRM_DIALOG: 'ToggleDepartmentListConfirmDialog',
  DOWNLOAD_DEPARTMENT_LIST_START: 'DownloadDepartmentListStart',
  DOWNLOAD_DEPARTMENT_LIST_END: 'DownloadDepartmentListEnd'
};